import fetchAx from "@/axios.js";
export default {
  namespaced: true,
  state: {
    customerList: [],
    isSaved: false,
    groupList: [],
    name: "",
    codeList: [],
    success: [],
    error: [],
    stokKodu: "",
    isEnded: false,
    stokKartList: {
      materialType: null,
      childMaterial: [],
    },
    birimTipi: [],
    kartTipi: [],
    defaultEvrakNo: "!600000000",
    evrakNo: "!600000000",
  },
  mutations: {
    setCustomerList(state, customerList) {
      state.customerList = customerList;
    },
    setIsSaved(state) {
      state.isSaved = !state.isSaved;
    },
    setName(state, name) {
      state.name === ""
        ? (state.name = name.replace(/\s+/g, ""))
        : (state.name = state.name + " " + name.replace(/\s+/g, ""));
    },
    setCodeList(state, codeList) {
      var updatedList = [];
      codeList.forEach((item, index) => {
        let list = {
          kod: item.kod,
          ad: state.name,
          aciklama: "",
          reftext01: "",
        };
        updatedList.push(list);
        item = list;
      });
      state.codeList = updatedList.map(function (item) {
        return item;
      });
    },
    setStokKodu(state, value) {
      var { kod, ad, kodEvrakNo, kodAlanNo } = value;
      state.stokKodu === ""
        ? (state.stokKodu = kod.replace(/\s+/g, ""))
        : (state.stokKodu = state.stokKodu + "" + kod.replace(/\s+/g, ""));
      state.groupList.push({
        kod: kod,
        ad: ad,
        kodEvrakNo: kodEvrakNo,
        kodAlanNo: kodAlanNo,
      });
    },
    setStokKartList(state, materialList) {
      state.stokKartList.materialType = materialList;
    },
    setEvrakNo(state, trnum) {
      state.evrakNo = state.evrakNo + "-" + trnum;
    },
    setSubEvrakNo(state, evrakNo) {
      state.evrakNo = evrakNo.EVRAKNO + "-" + evrakNo.TRNUM;
    },
    setChildMaterialList(state, childMaterial) {
      state.stokKartList.childMaterial.push(childMaterial);
    },
    setIsEnd(state) {
      state.isEnded = true;
    },
    setUnitType(state, value) {
      state.birimTipi = value;
    },
    setCardType(state, value) {
      state.kartTipi = value;
    },
    setResetData(state) {
      state.isEnded = false;
      state.stokKartList.childMaterial = [];
      state.stokKartList.materialType = null;
      state.birimTipi = [];
      state.kartTipi = [];
      state.defaultEvrakNo = "!600000000";
      state.evrakNo = "!600000000";
      state.stokKodu = "";
      state.codeList = [];
      state.name = "";
      state.success = [];
      state.errorr = [];
      state.groupList = [];
    },
    setErrorStatus(state, error) {
      state.error = error;
    },
    setSuccess(state, success) {
      state.success = success;
    },
  },
  getters: {
    _getCustomerList(state) {
      return state.customerList;
    },
    _getIsSaved(state) {
      return state.isSaved;
    },
    _getCodeList(state) {
      return Object.values(state.codeList);
    },
    _getSuccess(state) {
      return state.success;
    },
    _getMaterialList(state) {
      return state.stokKartList.materialType;
    },
    _getEvrakNo(state) {
      return state.evrakNo;
    },
    _getChildMaterial(state) {
      return state.stokKartList.childMaterial;
    },
    _isEnded(state) {
      return state.isEnded;
    },
    _getUnitType(state) {
      return state.birimTipi;
    },
    _getCardType(state) {
      return state.kartTipi;
    },
    _getStockCode(state) {
      return state.stokKodu;
    },
    _getError(state) {
      return state.error;
    },
  },
  actions: {
    async changeIsSaved({ commit }) {
      commit("setIsSaved");
    },
    async getGrupkod(context) {
      if (context.state.materialType !== null) {
        const kriterler = {
          metin1: "!600000000",
          queryKey: "TopluStokKartiAcmaSecenekleriGetir1",
        };
        await fetchAx
          .post("v1/Dynamic/GetQueryReplaceData", kriterler)
          .then((response) => {
            context.commit(
              "setStokKartList",
              JSON.parse(response.data.data.dataJson)
            );

            context.state.stokKartList.materialType.forEach((item) => {
              if (item.BITTIMI === "E") {
                context.commit("setIsEnd");
              }
            });
          })
          .catch((error) => {
            console.error("Error fetching data:", error);
          });
      }
    },
    async getSubKod(context, { materialTypes, subEvrak }) {
      if (!context.state.isEnded) {
        if (subEvrak) {
          await context.commit("setSubEvrakNo", materialTypes);
        } else {
          await context.commit("setEvrakNo", materialTypes);
        }
        const kriterler = {
          metin1: context.state.evrakNo,
          queryKey: "TopluStokKartiAcmaSecenekleriGetir2",
        };

        await fetchAx
          .post("v1/Dynamic/GetQueryReplaceData", kriterler)
          .then((response) => {
            context.commit(
              "setChildMaterialList",
              JSON.parse(response.data.data.dataJson)
            );
            context.state.stokKartList.childMaterial.forEach((subArray) => {
              subArray.forEach((item) => {
                if (item.BITTIMI === "E") {
                  context.commit("setIsEnd");
                }
              });
            });
          })
          .catch((error) => {
            console.error("Error fetching data:", error);
          });
      }
    },
    async getUnit(context) {
      const kriterler = {
        queryKey: "StokKartiBirimGetir",
      };
      await fetchAx
        .post("v1/Dynamic/GetQueryReplaceData", kriterler)
        .then((response) => {
          // context.commit("setStokKartList", JSON.parse(response.data.data.dataJson));
          context.commit(
            "setUnitType",
            JSON.parse(response.data.data.dataJson)
          );
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
        });
    },
    async getCard(context) {
      const kriterler = {
        queryKey: "StokKartiKartTipiGetir",
      };
      await fetchAx
        .post("v1/Dynamic/GetQueryReplaceData", kriterler)
        .then((response) => {
          // context.commit("setStokKartList", JSON.parse(response.data.data.dataJson));
          context.commit(
            "setCardType",
            JSON.parse(response.data.data.dataJson)
          );
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
        });
    },
    async resetAllData({ commit }) {
      await commit("setResetData");
    },
    async pushStockCode({ commit }, addStok) {
      commit("setStokKodu", addStok);
    },
    async pushAllCode({ commit }, value) {
      const jsonValue = {
        BIRLESIM: value.birlesim,
        ADET: value.adet,
      };
      let request = {
        FunctionName: "d7kRun",
        MacroName: "D7KSUP007",
        JsonParams: JSON.stringify(jsonValue),
        MacroKey: "TopluStokKartSayac",
      };
      try {
        await fetchAx.post("Com/RunMacroWithAuth", request).then((response) => {
          if (response.status == 200) {
            if (response.data.succeeded == false) {
              let error = {
                color: "danger",
                title: "Api Hatası",
                text: response.data.message,
                position: "top-center",
              };
              commit("setErrorStatus", error);
            } else {
              let success = {
                isSuccess: true,
                successText: "İşlem Başarılı...",
                successStatus: 2000,
              };
              commit("setSuccess", success);
              response = JSON.parse(
                JSON.parse(response.data.data)
                  .data.replace(/\#\#\#/g, '"')
                  .replace(/###/g, '""')
              );
              commit("setCodeList", response);
            }
          } else {
            let error = {
              color: "danger",
              title: "Api Hatası",
              text: response.data.message,
              position: "top-center",
            };
            commit("setErrorStatus", error);
          }
        });
      } catch {
        let error = {
          color: "danger",
          title: "Web Hatası",
          text: "Web tarafın bir sorun oluştu sistem yöneticiniz ile görüşünüz.!",
          acceptText: "Kapat",
          accept: null,
        };
        commit("setErrorStatus", error);
      }
    },
    async pushName({ commit }, name) {
      commit("setName", name);
    },
    async pushSaveData(context, payload) {
      const {
        selectedCardType,
        selectedUnitType,
        howMany,
        codeList,
        checkAuth,
        selectedCustomer,
        selectedKdv,
      } = payload;
      const jsonValue = {
        KARTTIPI: selectedCardType,
        BIRIMTIPI: selectedUnitType,
        KDV: selectedKdv,
        ADET: howMany,
        GRUPKODLARI: context.state.groupList,
        STOKKODLARI: codeList,
      };
      checkAuth ? jsonValue.GRUPKODLARI.push(selectedCustomer) : "";

      let request = {
        FunctionName: "d7kRun",
        MacroName: "D7KSUP007",
        JsonParams: JSON.stringify(jsonValue),
        MacroKey: "TopluStokKartOlustur",
      };

      try {
        await fetchAx.post("Com/RunMacroWithAuth", request).then((response) => {
          if (response.status == 200) {
            if (response.data.succeeded == false) {
              let error = {
                color: "danger",
                title: "Api Hatası",
                text: response.data.message,
                position: "top-center",
              };
              context.commit("setErrorStatus", error);
            } else {
              let success = {
                isSuccess: true,
                successText: "Kaydedildi..",
                successStatus: 2000,
              };
              context.commit("setSuccess", success);
              context.commit("setIsSaved");
            }
          } else {
            let error = {
              color: "danger",
              title: "Api Hatası",
              text: response.data.message,
              position: "top-center",
            };
            context.commit("setErrorStatus", error);
          }
        });
      } catch (e) {
        let error = {
          color: "danger",
          title: "Web Hatası",
          text: "Web tarafın bir sorun oluştu sistem yöneticiniz ile görüşünüz.!",
          acceptText: "Kapat",
          accept: null,
        };
        context.commit("setErrorStatus", error);
      }
    },
    async getCustomerList({ commit }) {
      const kriterler = {
        queryKey: "TopluStokKartiAcmaMusteriSecenekleriGetir",
      };
      try {
        await fetchAx
          .post("v1/Dynamic/GetQueryReplaceData", kriterler)
          .then((response) => {
            commit("setCustomerList", JSON.parse(response.data.data.dataJson));
          });
      } catch (error) {
        console.log(error);
      }

      // commit("setCustomerList");
    },
  },
};
